import { useGetAgendaItem } from "@/hooks/queryHooks/agendaItemHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { useUserStore } from "@/stores/userStore";
import { Link } from "react-router-dom";

export const AgendaItemSummaryItem = ({
  tenantId,
  agendaItemId,
}: {
  tenantId: string;
  agendaItemId: string;
}) => {
  const activeTeam = useUserStore((s) => s.activeTeam);
  const { data: agendaItem } = useGetAgendaItem(tenantId, agendaItemId);
  const path =
    agendaItemId && activeTeam !== "org"
      ? new AppUrlPath(tenantId).getAgendaItemPath(agendaItemId)
      : "";

  return (
    <Link
      className="block hover:underline"
      to={path}
    >{`${!agendaItemId ? "Unknown" : agendaItem?.name ?? "..."}`}</Link>
  );
};
